import { render, staticRenderFns } from "./LearningManagementSystem.vue?vue&type=template&id=76da9ece"
import script from "./LearningManagementSystem.vue?vue&type=script&lang=js"
export * from "./LearningManagementSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports